import React, { useEffect, useState } from 'react';
import { fetchLeadDashboard } from '../../api/leads';
import './leads.css';

const columns = [
  ['receivedAt', 'Received'], ['customer', 'Customer'], ['email', 'Email'],
  ['eventDate', 'Event Date'], ['eventType', 'Event Type'], ['zip', 'ZIP'],
  ['focus', 'Focused asset'], ['status', 'Status']
];

const metricLabels = [
  ['attractionImpressions', 'Attraction impressions'],
  ['attractionViews', 'Attraction views'],
  ['profileImpressions', 'Profile impressions'],
  ['profileViews', 'Profile views'],
  ['contactReveals', 'Contact reveals'],
  ['quoteRequests', 'Quote requests']
];

export default function Leads() {
  const [query, setQuery] = useState('');
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('receivedAt');
  const [sortDir, setSortDir] = useState('desc');
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ metrics: {}, leads: [], total: 0, page: 1, pageCount: 1 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    fetchLeadDashboard({ search, sortBy, sortDir, page, limit: 25 })
      .then(result => active && setData(result))
      .catch(err => active && setError(err?.message || 'Unable to load leads'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [search, sortBy, sortDir, page]);

  const sort = key => {
    setPage(1);
    if (sortBy === key) setSortDir(value => value === 'asc' ? 'desc' : 'asc');
    else { setSortBy(key); setSortDir('asc'); }
  };

  return (
    <div className="leads-page">
      <h1 className="h2 mb-4">Leads</h1>
      <div className="lead-metrics">
        {metricLabels.map(([key, label]) => (
          <div className="lead-metric" key={key}><strong>{Number(data.metrics?.[key] || 0).toLocaleString()}</strong><span>{label}</span></div>
        ))}
      </div>

      <form className="lead-search" onSubmit={event => { event.preventDefault(); setPage(1); setSearch(query.trim()); }}>
        <input value={query} onChange={event => setQuery(event.target.value)} placeholder="Search name, email, ZIP, attraction, or lead ID" aria-label="Search leads" />
        <button className="btn btn-primary" type="submit">Search</button>
        {(query || search) && <button className="btn btn-outline-secondary" type="button" onClick={() => { setQuery(''); setSearch(''); setPage(1); }}>Clear</button>}
      </form>

      {error && <div className="alert alert-danger">{error}</div>}
      <div className="lead-result-count">{data.total || 0} quote request{data.total === 1 ? '' : 's'}</div>
      <div className="table-responsive">
        <table className="table align-middle leads-table">
          <thead><tr>{columns.map(([key, label]) => (
            <th key={key}><button type="button" onClick={() => sort(key)}>{label}{sortBy === key ? (sortDir === 'asc' ? ' ▲' : ' ▼') : ''}</button></th>
          ))}</tr></thead>
          <tbody>
            {!loading && !data.leads?.length && <tr><td colSpan={columns.length} className="text-center text-muted py-4">No quote requests found.</td></tr>}
            {data.leads?.map(lead => <tr key={lead.id}>
              <td>{lead.receivedAt ? new Date(lead.receivedAt).toLocaleString() : '-'}</td>
              <td>{lead.customer || '-'}</td><td>{lead.email || '-'}</td><td>{lead.eventDate || '-'}</td>
              <td>{lead.eventType || '-'}</td><td>{lead.zip || '-'}</td><td>{lead.focus || '-'}</td>
              <td><span className="lead-status">{lead.status || 'new'}</span></td>
            </tr>)}
          </tbody>
        </table>
      </div>
      {loading && <div className="text-center py-3">Loading…</div>}
      <div className="lead-pagination">
        <button className="btn btn-outline-secondary" disabled={data.page <= 1 || loading} onClick={() => setPage(value => value - 1)}>Previous</button>
        <span>Page {data.page || 1} of {data.pageCount || 1}</span>
        <button className="btn btn-outline-secondary" disabled={data.page >= data.pageCount || loading} onClick={() => setPage(value => value + 1)}>Next</button>
      </div>
    </div>
  );
}
